var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRentersApplicants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.572 13.5717C26.3401 13.5717 24.5307 15.3811 24.5307 17.6131C24.5307 19.845 26.3401 21.6544 28.572 21.6544C30.804 21.6544 32.6134 19.845 32.6134 17.6131C32.6134 15.3811 30.804 13.5717 28.572 13.5717ZM23.8164 17.6131C23.8164 14.9866 25.9456 12.8574 28.572 12.8574C31.1985 12.8574 33.3277 14.9866 33.3277 17.6131C33.3277 20.2395 31.1985 22.3687 28.572 22.3687C25.9456 22.3687 23.8164 20.2395 23.8164 17.6131Z",
    fill: "#807E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0006 9.28557C11.6474 9.28557 8.92913 12.0038 8.92913 15.357C8.92913 18.7102 11.6474 21.4284 15.0006 21.4284C18.3537 21.4284 21.072 18.7102 21.072 15.357C21.072 12.0038 18.3537 9.28557 15.0006 9.28557ZM8.21484 15.357C8.21484 11.6094 11.2529 8.57129 15.0006 8.57129C18.7482 8.57129 21.7863 11.6094 21.7863 15.357C21.7863 19.1046 18.7482 22.1427 15.0006 22.1427C11.2529 22.1427 8.21484 19.1046 8.21484 15.357Z",
    fill: "#807E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0008 24.9994C11.0337 24.9994 7.48528 26.4642 5.0688 28.7698C3.10607 30.6424 1.89361 33.0647 1.7933 35.7137H28.2084C28.0471 31.4653 25.019 27.787 20.6297 26.0519C18.9232 25.3773 17.0156 24.9994 15.0008 24.9994ZM4.57573 28.253C7.1328 25.8133 10.8611 24.2852 15.0008 24.2852C17.1048 24.2852 19.1016 24.6798 20.8922 25.3876C25.6111 27.253 28.9294 31.3143 28.9294 36.0709V36.428H1.07227V36.0709C1.07227 33.0622 2.40315 30.3258 4.57573 28.253Z",
    fill: "#807E8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4305 32.1432H38.215V31.7861C38.215 28.475 35.906 25.6608 32.6446 24.3716C31.4062 23.882 30.0258 23.6094 28.5722 23.6094C26.9437 23.6094 25.4061 23.9517 24.0568 24.5586C24.3076 24.7071 24.5539 24.862 24.7953 25.0229C25.9406 24.5749 27.22 24.3237 28.5722 24.3237C29.9366 24.3237 31.2278 24.5796 32.382 25.0359C35.3127 26.1943 37.3318 28.6254 37.4907 31.4289H30.1653C30.2607 31.6638 30.3492 31.902 30.4305 32.1432Z",
    fill: "#807E8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRentersApplicants);
export default __webpack_public_path__ + "static/media/no-renters-applicants.21cac1d6.svg";
export { ForwardRef as ReactComponent };